export const COLORS = {
  blue: "rgba(92, 119, 235, 1.000)",
  gray: "#bbbbbb",
  lighterGray: "#eee",
  black: "black",
  darkerBlue: "#2A366B",
};

export const TOOLTIP_OFFSET = 18;
